import React, { useEffect, useState, useMemo } from "react"
import { StaticImage } from "gatsby-plugin-image"
import { Link } from "gatsby"
import SwiperCore, { Navigation, Pagination } from "swiper"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/swiper-bundle.css"

SwiperCore.use([Navigation, Pagination])

const ShopSubCategories = ({
  categories,
  setCurrentCategory,
  currentCategory,
  location
}) => {
//   const currentCategories = categories.map(item => {
//     return {
//         fieldValue: item.fieldValue,
//         ...item.nodes[0],
//         currentCategory: item.nodes[0].productSubcategory.filter(cat => cat._id === item.fieldValue)[0]
//     }
//   })

  const getCategory = categories.find(el => el._id === currentCategory)
  const cat = categories.findIndex(el => el._id === currentCategory)
  const [activeIndex, setActiveIndex] = useState(parseInt(cat))

  console.log("currentCategories", categories)

  // useEffect(() => {
    

  //   console.log("cat", parseInt(cat))
  //   setActiveIndex(parseInt(cat))
  // }, [activeIndex])

  const handleOnClick =(id, idx)=> {
    setActiveIndex(idx)
    setCurrentCategory(id)
    // localStorage.setItem("activeIndex", idx)
    // window.location.pathname = `/sub${getCategory.slug.current}`
  }
  // useMemo(() => {
  //   setActiveIndex(localStorage.getItem("activeIndex"))
  // }
  // useMemo(() => {
  //   if(localStorage.getItem("activeIndex") === null) {
  //     setActiveIndex(0)
  //   }
  //   setActiveIndex(localStorage.getItem("activeIndex"))
  // }, [])

  
  console.log("idx", activeIndex)
  return (
    <Swiper
      navigation
      className="shop-category"
      spaceBetween={20}
      slidesPerView={6}
      // loop={true}
      // autoplay={{
      //   delay: 5000,
      //   disableOnInteraction: false,
      // }}
      breakpoints={{
        320: {
          slidesPerView: 1,
        },
        640: {
          slidesPerView: 1,
        },

        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 4,
        },
        1025: {
          slidesPerView: 5,
        },
      }}
    >
      {categories?.length > 0 &&
        categories.map((category, idx) => {
            let active = false
            if (category._id === 24) {
              if (
                !currentCategory ||
                currentCategory === category._id
              )
                active = true
            } else {
              active = currentCategory === category._id
            }

            

            return (
              <SwiperSlide
                style={{ padding: 50, cursor: "pointer", boxShadow: active ? `0px 0px 5px 4px ${category.themeColor !== null ? category.themeColor : "#ca2a78"}` : "" }}
                className={`category-item bg-white rounded text-center ${
                  active ? "active-product" : ""
                }`}
                key={category._id}
                onClick={() => handleOnClick(category._id, idx)}
              >
                
                <h4 className="text-dark">{category?.title}</h4>
                {category?.subtitle && <p className="text-dark">({category?.subtitle})</p>} 
                <Link onClick={() => handleOnClick(category._id, idx)} to={category?.slug?.current}/>
              </SwiperSlide>
            )
          })}
    </Swiper>
  )
}

export default ShopSubCategories
